import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private readonly routes: Router,
    private readonly loginService: LoginService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    
    // Check if route requires specific permissions
    const requiredPermissions = next.data['requiredPermissions'] as string[];
    
    if (requiredPermissions && requiredPermissions.length > 0) {
            // Check permissions using LoginService
      return this.loginService.currentUser$.pipe(
        map(user => {
          if (!user) {
            this.routes.navigate(['/login']);
            return false;
          }

          const hasPermission = this.loginService.hasAnyPermission(requiredPermissions);
          if (!hasPermission) {
            this.routes.navigate(['/']); // Redirect if no permission
            return false;
          }
          
          return true;
        }),
        catchError(() => {
          this.routes.navigate(['/login']);
          return of(false);
        })
      );
    }
    
    // Fallback to basic authentication check
    return this.loginService.currentUser$.pipe(
      map(user => {
        if (!user) {
          this.routes.navigate(['/login']);
          return false;
        }
        return true;
      }),
      catchError(() => {
        this.routes.navigate(['/login']);
        return of(false);
      })
    );
  }
}
